import React, { useRef, useState, useEffect } from 'react';
import { usePartnerContext } from '../Context/PartnerContext';
import EmployeeView from '../../views/PartnerView/EmployeeView';
import { useProgressBar } from '../../views/ProgressBar';



const EmployeeComponent = () => {

    const data = useRef('');
    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false);

    const error = useRef('');
    const { embployee, GetEmployee } = usePartnerContext();
    const { showProgress } =useProgressBar();
    const getData = async () => {

        try {
            showProgress(true);
            //         const response = await fetchPartner();
            //         data.current = response.data;
            await GetEmployee();
            
            setLoading(false); // Set loading to false once data is fetched
            //          
            //         console.log(response.data);
            showProgress(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            error.current = 'Failed to fetch data.';
        }
    };

    useEffect(() => {
        if (!didFetch.current) {
            getData();
            didFetch.current = true; // Mark the API call as done
        }
    });

    return (
        <div>
      
            {!loading && embployee != null && <EmployeeView />}
        </div>
        // 
        // 
    )
    // return <ServiceView Servicesdata={service} />

};

export default EmployeeComponent;
